import React, { useEffect, useState } from "react";
import {
  Badge,
  Container,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
  Form,
  Label,
  Input,
} from "reactstrap";

import { Link, useNavigate } from "react-router-dom";
import { useMemo } from "react";
import { useTable, usePagination, useGlobalFilter } from "react-table";
import {
  Table,
  Row,
  Col,
  Card,
  CardBody,
  Modal,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import classnames from "classnames";
import Select from "react-select";
import ReactSelect from "react-select";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import axios from "axios";

import Draggable, { DraggableCore } from "react-draggable";
import { Resizable, ResizableBox } from "react-resizable";
import Dropzone from "react-dropzone";
import configure from "configure";

const FixedProjectHeader = ({
  projects,
  setCurrentProject,
  CurrentProject,
  type,
  setProjectTypeChange,
  project,
  generalTask,
  formPopup,
  setFormPopup,
  projectType,
  setProjectType,
  columns,
  // data1,
  data,
  setData,
  setAccessDenied,
  allData,
  globalFilter,
  setGlobalFilter,
  setHeaderDateTxt,
  setAllCol,
  selectToMove,
  cancelBtn,
  DMproject,
  AllHosting,
  hostingType,
  setHostingType,
  CurrentMonth,
  notAnsweredTickets,
  openTickets,
  inProgressTickets,
  answeredTickets,
  onHoldTickets,
  closedTickets,
  setSupportType,
  supportType,
  supportBtn,
  setAddTicket,
  addTicket,
  isSupport,
  cancelBtn2,
  notAnsweredTickets2,
  openTickets2,
  inProgressTickets2,
  answeredTickets2,
  onHoldTickets2,
  closedTickets2,
  Todays,
  setTodays,
}) => {
  const [fixedContent, setFixedContent] = useState(false);
  //   const [addTicket, setAddTicket] = useState(false)
  const [boxWidth, setBoxWidth] = useState(0);
  const [boxHeight, setBoxHeight] = useState(0);
  const [addtask, setAddTask] = useState(false);
  // const [filterBoxWidth, setFilterBoxWidth] = useState(0)

  const navigate = useNavigate();

  document.addEventListener("scroll", () => {
    if (window.scrollY > 165) {
      setFixedContent(true);
    } else {
      setFixedContent(false);
    }
  });

  // popup upate width
  useEffect(() => {
    const updateHeight = () => {
      const viewportHeight = window.innerHeight;
      setBoxHeight(viewportHeight * 20);
    };
    const updateWidth = () => {
      const viewportWidth = window.innerWidth;
      setBoxWidth(viewportWidth * 0.72);
      // setFilterBoxWidth(viewportWidth * 72)
    };
    updateWidth();
    // updateHeight()
    window.addEventListener("resize", updateWidth);
    return () => window.removeEventListener("resize", updateWidth);
  }, []);

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      if (setAddTicket) {
        setAddTicket(false);
      }
      if (setAddTask) {
        setAddTask(false);
      }
      if (formPopup) {
        setFormPopup(false);
      }
      if (addTicket) {
        setAddTicket(false);
      }
    }
  });
  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
      // data1,
    },
    useGlobalFilter,
    usePagination
  );

  const { pageIndex, pageSize } = state;
  useEffect(() => {
    setPageSize(50);
  }, []);

  const [name_modal, setNameModal] = useState(false);
  const [title, setTitle] = useState("");

  const [viewData, setViewData] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [selectedFiles1, setselectedFiles1] = useState([]);
  const [relatedOptions, setRelatedOptions] = useState();
  const [salesOptions, setSalesOptions] = useState();
  const [leadsOptions, setLeadsOptions] = useState();
  const [workOptions, setWorkOptions] = useState();
  const [projectOptions, setProjectOptions] = useState();
  const [moveToClose, setMoveToClose] = useState();

  const Related_options = [
    { label: "- Select -", value: "- Select -" },
    { label: "Project", value: "Project" },
    { label: "Contract", value: "Contract" },
  ];
  const relateds_Options = Related_options.map((option) => ({
    value: option.value,
    label: option.label,
  }));
  const contracts = [
    { label: "- Select -", value: "- Select -" },
    { label: "Global Biotech", value: "Global Biotech" },
    { label: "Global Infoteh", value: "Global Infoteh" },
    { label: "Indian Infotech", value: "Indian Infotech" },
  ];

  const [selectedRelated, setSelectedRelated] = useState(
    Related_options[0].value
  );
  const [addRelatedSubOptions, setAddRelatedSubOptions] = useState(null);
  const [selectedProject, setSelectedProject] = useState(null);
  const [selectedContract, setSelectedContract] = useState(null);

  const handleChangedRelated = (selectedOption) => {
    setSelectedRelated(selectedOption.value);
    setAddRelatedSubOptions(null);
  };

  function handleAcceptedFiles1(files) {
    const updatedFiles = files.map((file) => ({
      ...file,
      preview: URL.createObjectURL(file),
      formattedSize: formatBytes(file.size),
    }));

    // Merge newly accepted files with existing selected files
    setselectedFiles1((prevFiles) => [...prevFiles, ...updatedFiles]);
  }

  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }

  const KeyAccountManager = [
    { label: "Rahul Ovhal", value: "1" },
    { label: "Zain", value: "2" },
    { label: "Manav", value: "3" },
  ];
  const status_option = [
    { label: "Not Answered", value: "Not Answered" },
    { label: "Open", value: "Open" },
    { label: "In Progress", value: "In Progress" },
    { label: "Answered", value: "Answered" },
    { label: "On Hold", value: "On Hold" },
    { label: "Closed", value: "Closed" },
  ];
  const gTask_status_option = [
    { label: "Not Answered", value: "Not Answered" },
    { label: "In Progress", value: "In Progress" },
    { label: "Complete", value: "Complete" },
  ];

  const project_option = [
    { label: "Earth Development", value: "Earth Development" },
    { label: "Mars Development", value: "Mars Development" },
    { label: "Jean Therapy", value: "Jean Therapy" },
    { label: "Prop User", value: "Prop User" },
  ];
  const colourStyles = {
    menuList: (styles) => ({
      ...styles,
      background: "white",
    }),
    menu: (base) => ({
      ...base,
      zIndex: 1200,
    }),
  };

  const locationOptions = [
    { label: "India", value: "India" },
    { label: "UK", value: "UK" },
  ];

  const assignee = [
    { label: "Rahul Ovhal", value: "1" },
    { label: "Zain", value: "2" },
    { label: "Manav", value: "3" },
    { label: "Divyansh", value: "4" },
    { label: "Nimesh", value: "5" },
  ];

  const priority = [
    { label: "Low", value: "Low" },
    { label: "Medium", value: "Medium" },
    { label: "High", value: "High" },
  ];
  const relatedTo = [
    { label: "Human Resource", value: "LHuman Resourceow" },
    { label: "Finance", value: "Finance" },
    { label: "Sales", value: "Sales" },
    { label: "Work", value: "Work" },
  ];
  const Type = [
    { label: "Bug", value: "Bug" },
    { label: "Suggestion", value: "Suggestion" },
  ];

  const related = [
    { label: "Project", value: "Project" },
    { label: "Contract", value: "Contract" },
  ];
  const project_type = [
    { label: "Earth Development", value: "Earth" },
    { label: "Mars", value: "Mars" },
  ];

  const handleClick = (id) => {
    if (setProjectTypeChange) {
      setProjectTypeChange(id);
    }
    if (allData) {
      setProjectType(id);
      if (id == "1") {
        if (setAllCol) {
          setAllCol(true);
        }
        setData(allData?.project2);
        setHeaderDateTxt("Due date");
      } else if (id == "2") {
        const filterData = allData?.project2?.filter((item) => {
          return item.status == "Not Started";
        });
        setData(filterData);
      } else if (id == "3") {
        const filterData = allData?.project2?.filter((item) => {
          return item.status == "In Progress";
        });
        setData(filterData);
      } else if (id == "4") {
        const filterData = allData?.project2?.filter((item) => {
          return item.status == "On Hold";
        });
        if (setAllCol) {
          setAllCol(false);
        }
        setHeaderDateTxt("On Hold Date");
        setData(filterData);
      } else if (id == "5") {
        const filterData = allData?.project2?.filter((item) => {
          return item.status == "Cancelled";
        });
        setHeaderDateTxt("Cancelled Date");
        setData(filterData);
      } else if (id == "6") {
        const filterData = allData?.project2?.filter((item) => {
          return item.status == "Finished";
        });
        if (setAllCol) {
          setAllCol(false);
        }
        setHeaderDateTxt("Finished Date");
        setData(filterData);
      }
    }
  };

  const handleAddTask = async () => {
    setLoading(true);
    const formData = new FormData();
    formData.append("user_id", localStorage.getItem("auth_id"));
    formData.append("module_id", 8);
    try {
      const response = await axios({
        method: "post",
        url: `${configure.apiUrl}/earth_permission`,
        data: formData,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      });
      if (response) {
        setLoading(false);

        if (response.data.data.india[3] == 1 || response.data.data.uk[3] == 1) {
          setAddTask(true);
        } else {
          setAccessDenied(true);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div
        className={`flex-column fixed-buttons pt-2 ${
          fixedContent ? "d-flex" : "d-none"
        }`}
      >
        {project == "true" && (
          <Link
            // to={`${configure.appUrl}work/add-project`}
            className="btn btn-save s fix-btn btn-label pe-0"
            // onClick={() => handleAddProject()}
          >
            <i className="fas fa-plus me-2 icon-size label-icon"></i>
            <span>Project</span>
          </Link>
        )}

        {DMproject == "true" && (
          <Link
            // to={`${configure.appUrl}work/add-project`}
            className="btn btn-save s fix-btn btn-label pe-0"
            // onClick={() => handleAddProject()}
          >
            <i className="fas fa-plus me-2 icon-size label-icon"></i>
            <span>Add Project</span>
          </Link>
        )}

        {/* {supportBtn  && (
          <Link
            onClick={() => setAddTicket(true)}
            className="btn btn-save s fix-btn btn-label pe-0"
          >
            <i className="fas fa-plus me-2 icon-size label-icon"></i>
            <span>Ticket</span>
          </Link>
        )} */}
        {generalTask == "true" && (
          <Link
            onClick={() => handleAddTask()}
            className="btn btn-save s fix-btn btn-label pe-0"
          >
            <i className="fas fa-plus me-2 icon-size label-icon"></i>
            <span>Task</span>
          </Link>
        )}
        {selectToMove == "true" && (
          <>
            <Link
              onClick={() => setMoveToClose(true)}
              className="btn btn-save s fix-btn btn-label pe-0 my-2"
            >
              <i className="bi bi-sign-turn-right me-2 icon-size label-icon"></i>
              <span>Move To Close</span>
            </Link>
          </>
        )}

        {cancelBtn == "true" ? (
          <button
            onClick={() => navigate(-1)}
            className="btn btn-red s fix-btn btn-label pe-0"
          >
            <i className="dripicons-cross me-2 icon-center label-icon"></i>
            <span>Cancel</span>
          </button>
        ) : (
          ""
        )}
      </div>

      <Row className="mb-4 align-items-center" id="support-header">
        <Col
          md={isSupport ? 12 : 9}
          className="pr-0 support-status-part general-status-part"
        >
          <div className="d-flex justify-content-between align-items-center">
            <div className="d-flex justify-content-start w-100 text-center align-items-center gap-3">
              {/* Hosting Tabs  */}
              {AllHosting ? (
                <a
                  href="#"
                  className={`"text-green pt-2 px-2 rounded hosting-status ${
                    hostingType == "1" ? "activeProjectTab" : ""
                  }`}
                  onClick={() => setHostingType("1")}
                >
                  <h4>0</h4>
                  <h4>All</h4>
                </a>
              ) : null}
              {CurrentMonth ? (
                <a
                  href="#"
                  className={`"text-green pt-2 px-2 rounded hosting-status ${
                    hostingType == "2" ? "activeProjectTab" : ""
                  }`}
                  onClick={() => setHostingType("2")}
                >
                  <h4>0</h4>
                  <h4>Current Month</h4>
                </a>
              ) : null}

              {/* Support Tabs  */}
              {type === "Support" && (
                <>
                  <a
                    href="#"
                    className={`"text-green pt-2 px-2 rounded hosting-status ${
                      supportType == "3" ? "activeProjectTab" : ""
                    }`}
                    onClick={() => setSupportType("3")}
                  >
                    <h4>{notAnsweredTickets || 0}</h4>
                    <h5>Not Answered</h5>
                  </a>
                  <a
                    href="#"
                    className={`"text-green pt-2 px-2 rounded hosting-status ${
                      supportType == "4" ? "activeProjectTab" : ""
                    }`}
                    onClick={() => setSupportType("4")}
                  >
                    <h4>{openTickets || 0}</h4>
                    <h4>Open</h4>
                  </a>
                  <a
                    href="#"
                    className={`"text-green pt-2 px-2 rounded hosting-status ${
                      supportType == "5" ? "activeProjectTab" : ""
                    }`}
                    onClick={() => setSupportType("5")}
                  >
                    <h4>{inProgressTickets || 0}</h4>
                    <h4>In Progress</h4>
                  </a>
                  <a
                    href="#"
                    className={`"text-green pt-2 px-2 rounded hosting-status ${
                      supportType == "6" ? "activeProjectTab" : ""
                    }`}
                    onClick={() => setSupportType("6")}
                  >
                    <h4>{answeredTickets || 0}</h4>
                    <h4>Answered</h4>
                  </a>
                  <a
                    href="#"
                    className={`"text-green pt-2 px-2 rounded hosting-status ${
                      supportType == "7" ? "activeProjectTab" : ""
                    }`}
                    onClick={() => setSupportType("7")}
                  >
                    <h4>{onHoldTickets || 0}</h4>
                    <h4>On Hold</h4>
                  </a>
                  <a
                    href="#"
                    className={`"text-green pt-2 px-2 rounded hosting-status ${
                      supportType == "8" ? "activeProjectTab" : ""
                    }`}
                    onClick={() => setSupportType("8")}
                  >
                    <h4>{closedTickets || 0}</h4>
                    <h4>Closed</h4>
                  </a>
                </>
              )}

              {notAnsweredTickets2 && (
                <a
                  className={` "d-flex flex-row align-items-center dash_support_box not_answered_ticket ${
                    supportType == "3" ? "activeProjectTab" : ""
                  } `}
                  onClick={() => setSupportType("3")}
                >
                  <h5 className=" mb-0">Not Started : </h5>
                  <h5 className="countss mb-0 ms-2">10</h5>
                </a>
              )}
              {openTickets2 && (
                <a
                  className={` "d-flex flex-row align-items-center justify-content-start dash_support_box open_ticket ${
                    supportType == "4" ? "activeProjectTab" : ""
                  } `}
                  onClick={() => setSupportType("4")}
                >
                  <h5 className="text-purple mb-0">Open : </h5>
                  <h5 className="text-purple mb-0 ms-2">15</h5>
                </a>
              )}
              {inProgressTickets2 && (
                <a
                  className={` "d-flex flex-row align-items-center justify-content-start dash_support_box inprogress_ticket ${
                    supportType == "5" ? "activeProjectTab" : ""
                  } `}
                  onClick={() => setSupportType("5")}
                >
                  <h5 className="text-purple mb-0">In Progress : </h5>
                  <h5 className="text-purple mb-0 ms-2">5</h5>
                </a>
              )}
              {answeredTickets2 && (
                <a
                  className={` "d-flex flex-row align-items-center justify-content-start dash_support_box answered_ticket ${
                    supportType == "6" ? "activeProjectTab" : ""
                  } `}
                  onClick={() => setSupportType("6")}
                >
                  <h5 className="text-purple mb-0">Answered : </h5>
                  <h5 className="text-purple mb-0 ms-2">5</h5>
                </a>
              )}
              {onHoldTickets2 && (
                <a
                  className={` "d-flex flex-row align-items-center justify-content-start dash_support_box onHold_ticket ${
                    supportType == "7" ? "activeProjectTab" : ""
                  } `}
                  onClick={() => setSupportType("7")}
                >
                  <h5 className="text-purple mb-0">On Hold : </h5>
                  <h5 className="text-purple mb-0 ms-2">5</h5>
                </a>
              )}
              {closedTickets2 && (
                <a
                  className={` "d-flex flex-row align-items-center justify-content-start dash_support_box closed_ticket ${
                    supportType == "8" ? "activeProjectTab" : ""
                  } `}
                  onClick={() => setSupportType("8")}
                >
                  <h5 className="text-purple mb-0"> Closed : </h5>
                  <h5 className="text-purple mb-0 ms-2">5</h5>
                </a>
              )}
            </div>
          </div>
        </Col>
        <Col
          md={3}
          className="d-flex align-items-center justify-content-end pl-0 support-action-part"
        >
          <div className="text-md-end">
            {/* {project == "true" && (
              <Link
                className="s btn text-white me-2 btn-save btn-label"
                onClick={() => handleAddProject()}
              >
                <i className="fas fa-plus me-2 icon-size label-icon"></i>Project
              </Link>
            )}
             */}
            {cancelBtn ? (
              <button
                onClick={() => navigate(-1)}
                className="s btn btn-red btn-label"
              >
                <i className="dripicons-cross me-2 icon-center label-icon"></i>
                CANCEL
              </button>
            ) : null}
          </div>
        </Col>
      </Row>

      <Row>
        <div className="col-md-12 my-4 d-flex">
          <div className="col-md-4 d-flex justify-content-start align-items-center">
              <select
                className="s me-4 form-select mb-2"
                style={{ width: "100px" }}
                value={pageSize}
                onChange={(e) => setPageSize(e.target.value)}
              >
                {[10, 25, 50, 100].map((pageSize) => (
                  <option key={pageSize} value={pageSize}>
                    Show {pageSize}
                  </option>
                ))}
              </select>
              {/* {isSupport && (
                <select
                  className="form-select me-2 mb-2"
                  value={CurrentProject}
                  onChange={(e) => setCurrentProject(e.target.value)}
                >
                  <option value={""}>Select</option>
                  {projects?.map((item) => (
                    <option key={item?.value} value={item?.value}>
                      {item?.label}
                    </option>
                  ))}
                </select>
              )} */}
          </div>

          <div className="col-md-8 d-flex justify-content-end align-items-center">
            {/* {support == "true" && (
              <div className="mb-2">
                <button
                  onClick={() => setFormPopup(!formPopup)}
                  className="btn btn-outline-secondary  me-3"
                >
                  <i className="fas fa-filter"></i>
                </button>
              </div>
            )} */}

            {isSupport && (
              <>
                <button
                  onClick={() => setTodays(!Todays)}
                  className={`btn mb-2 btn-Today ${Todays ? "btn-active" : ""}`}
                >
                  {`Today's Reply`}
                </button>
              </>
            )}

            <div className="search-box">
              <div className="position-relative">
                <label htmlFor="search-bar-0" className="search-label">
                  <span id="search-bar-0-label" className="sr-only">
                    Search this table
                  </span>
                  <input
                    onChange={(e) => setGlobalFilter(e.target.value)}
                    id="search-bar-0"
                    type="text"
                    className="s form-control rounded "
                    placeholder={` Search...`}
                    value={globalFilter || ""}
                  />
                </label>
                <i className="bx bx-search-alt search-icon"></i>
              </div>
            </div>
            {isSupport && (
              <Link
                className="s btn text-white me-2 ms-3 mb-2 btn-save btn-label"
                onClick={() => setAddTicket(true)}
              >
                <i className="fas fa-plus me-2 icon-size label-icon"></i>Ticket
              </Link>
            )}

            {cancelBtn2 ? (
              <button
                onClick={() => navigate(-1)}
                className="s btn btn-red btn-label ms-2 mb-2"
              >
                <i className="dripicons-cross me-2 icon-center label-icon"></i>
                CANCEL
              </button>
            ) : null}
          </div>
        </div>

        {formPopup ? (
          <Draggable>
            <ResizableBox
              width={boxWidth}
              id="support-filter"
              style={{
                position: "fixed",
                top: "24%",
                right: "6%",
                zIndex: "1055",
                backgroundColor: "#fff",
                minWidth: "90%",
              }}
            >
              <div>
                <Form>
                  <Row className="align-items-end">
                    <Row
                      className="d-flex flex-wrap pe-0 me-0"
                      // style={{ width: "100%" }}
                    >
                      <div className="col-3 mt-2 ps-1 pe-0">
                        <label htmlFor="">Project</label>
                        <Select
                          placeholder="Select Project"
                          className="basic-multi-select"
                          classNamePrefix=" select"
                          styles={colourStyles}
                          options={project_option}
                          closeMenuOnSelect={false}
                          isMulti
                          // onChange={e => setStatus(e)}
                        />
                      </div>
                      <div className="col-3 mt-2 ps-2 pe-0">
                        <label htmlFor="">Developer</label>
                        <ReactSelect
                          placeholder="Select Developers"
                          className="basic-multi-select "
                          classNamePrefix="select"
                          options={KeyAccountManager}
                          isMulti="true"
                        />
                      </div>
                      <div className="col-2 mt-2 ps-2 pe-0">
                        <label htmlFor="">Status</label>
                        <Select
                          placeholder="Select Status"
                          className="basic-multi-select"
                          classNamePrefix=" select"
                          styles={colourStyles}
                          options={status_option}
                          closeMenuOnSelect={false}
                          isMulti
                          // onChange={e => setStatus(e)}
                        />
                      </div>

                      <div className="col-md-4 d-flex justify-content-end align-items-end gap-2">
                        <a
                          className="btn  btn-danger me-1"
                          style={{
                            fontSize: "14px",
                            backgroundColor: "#fed36d",
                            borderColor: "#fed36d",
                            color: "black",
                          }}
                          // onClick={() => handleClear()}
                        >
                          Clear Filters
                        </a>
                        <button className="btn  btn-save btn-label me-1">
                          <i className="fas fa-filter search-icon label-icon"></i>{" "}
                          Filter
                        </button>
                        <a
                          className="btn btn-red btn-label me-1"
                          onClick={() => setFormPopup(false)}
                        >
                          <i className="dripicons-cross label-icon"></i> Close
                        </a>
                      </div>
                    </Row>
                  </Row>
                </Form>
                {/* <i className="bi bi-triangle-fill pop-icon"></i> */}
              </div>
            </ResizableBox>
          </Draggable>
        ) : null}
      </Row>
    </>
  );
};

export default FixedProjectHeader;
